import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HandlingUnitItemState } from './handling-unit-item.state';
import { SetInitialStateFacade } from '../../../../common/models';
import { HandlingUnitItemInitialState, SetHandlingUnitItemParams } from './handling-unit-item.actions';
import { MonitoringPageType } from '../../monitoring/constants';

@Injectable({ providedIn: 'root' })
export class HandlingUnitItemFacade implements SetInitialStateFacade {
  handlingUnitNumber$: Observable<string> = this.store.select(HandlingUnitItemState.getHandlingUnitNumber);
  deliveryNoteNumber$: Observable<string> = this.store.select(HandlingUnitItemState.getDeliveryNoteNumber);
  sapId$: Observable<string> = this.store.select(HandlingUnitItemState.getSapId);
  hasParentRoute$: Observable<boolean> = this.store.select(HandlingUnitItemState.hasParentRoute);
  monitoringPageType$: Observable<MonitoringPageType> = this.store.select(HandlingUnitItemState.getMonitoringPageType);

  constructor(private store: Store) {}

  setHandlingUnitParams(params: {
    handlingUnitNumber: string;
    deliveryNoteNumber: string;
    sapId: string;
    parentRoute: boolean;
    monitoringPageType: MonitoringPageType;
  }): void {
    this.store.dispatch(new SetHandlingUnitItemParams(params));
  }

  setInitialState(): void {
    this.store.dispatch(new HandlingUnitItemInitialState());
  }
}
